import React from 'react';
import { FieldProps } from 'formik';
import { Textarea } from '../ui/Textarea';
import { cn } from '../../utils/cn';

interface AreaFieldOwnProps {
  label?: string;
  limit?: number;
  disabled?: boolean;
  placeholder?: string;
  rows?: number;
  className?: string;
  required?: boolean;
}

type AreaFieldProps = FieldProps & AreaFieldOwnProps;

export const AreaField: React.FC<AreaFieldProps> = ({
  field,
  form: { touched, errors, submitCount },
  label,
  limit,
  disabled,
  placeholder,
  rows = 5,
  className,
  required,
}) => {
  const hasError =
    (touched[field.name] && !!errors[field.name]) || (!!errors[field.name] && submitCount > 0);
  const errorMsg = hasError ? (errors[field.name] as string) : null;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <label htmlFor={field.name} className="text-sm font-medium text-neutral-700">
          {label}
          {required && <span className="text-destructive ml-0.5">*</span>}
        </label>
      )}
      <div className="relative">
        <Textarea
          id={field.name}
          data-testid={`area-field-${field.name}`}
          disabled={disabled}
          placeholder={placeholder}
          maxLength={limit}
          rows={rows}
          aria-invalid={hasError}
          {...field}
        />
        {limit && (
          <span className="absolute bottom-2 right-2 text-xs text-neutral-400">
            {field.value?.length || 0}/{limit}
          </span>
        )}
      </div>
      {hasError && <span className="text-destructive text-xs">{errorMsg}</span>}
    </div>
  );
};
